import moment from 'moment';
import { AppConfig, AppPublicRoutes } from '../config/config';

export const emailSplitter = email => {
    return email ? email.split('@') : [];
};

export const capitalize = (s: string) => s && s[0].toUpperCase() + s.slice(1);

export const isMobileScreen = () => {
    return window.innerWidth <= 375 ? true : false;
};
export const noop = () => {};

export const getResponseError = error => {
    const { response } = error || { response: { status: '', data: { message: '' } } };
    const { status, data } = response;
    const { message } = data;

    return {
        status,
        message,
    };
};

export const isValidEmail = email => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const lastScanFormat = lastScanDate => {
    return lastScanDate
        ? moment(new Date(lastScanDate).getTime()).format('DD MMM YYYY')
        : '';
};

export const iterateStorage = storage => {
    for (var a in storage) {
        if (typeof storage[a] !== 'function' && a.indexOf(AppConfig.storagePrefix) > -1) {
            delete storage[a];
        }
    }
};

export const triggerSignOut = () => {
    iterateStorage(localStorage);
    iterateStorage(sessionStorage);

    window.location.href = createUrl('');
};

export const formatAssetName = (asset: string) => {
    return asset.replaceAll('_', ' ');
};

export const removeEmptyProps = <T extends Record<string, unknown>>(obj: T) => {
    const entries = Object.entries(obj).filter(
        ([, value]) => value !== null && value !== undefined
    );
    return Object.fromEntries(entries);
};

export const getQueryString = params =>
    Object.entries(removeEmptyProps(params))
        .map(
            ([key, value]) =>
                encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        )
        .join('&');

export const isFeatureEnabled = featureKey => {
    const disabled = process.env.REACT_APP_DISABLED_FEATURES;
    return disabled && disabled.indexOf(featureKey) > -1 ? false : true;
};

export const isPublicPage = pathname => {
    return AppPublicRoutes.indexOf(pathname) > -1 ? true : false;
};

export const createUrl = pathname => {
    return `${AppConfig.baseRoute}${pathname}`;
};
